import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { styled } from '@mui/material/styles';
import {
  Stack,
  Alert,
  Snackbar,
  Typography,
  Card,
  AppBar,
  Toolbar,
  IconButton,
  TextField,
  Box
} from '@mui/material';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
// components
import { MHidden } from '../../components/@material-extend';
import AccountPopover from './AccountPopover';
import { NOTIFICATION_WIDTH_XL, NOTIFICATION_WIDTH_XLM } from '.';
import { useAuth } from '../../components/customContextProviders/AuthContext';
import { APP_CONSTANTS } from '../../URLConstants';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 85;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 80;

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1)
  }
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
  search: PropTypes.bool,
  searchFunction: PropTypes.func,
  searchText: PropTypes.string
};

export default function DashboardNavbar({
  onOpenSidebar,
  search,
  searchFunction,
  searchText,
  name,
  selectedVendorTab = '1',
  selectedFotaTab = '1',
  selectedCampaignAndSchemsTab = '1',
  isChanakya
}) {
  const location = useLocation();
  const { userLoginOrg } = useAuth();

  const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    backgroundColor: 'transparent',

    position: 'fixed',
    top: 0,
    // left: DRAWER_WIDTH + 1,
    // right: NOTIFICATION_WIDTH_XL,
    // // width: `calc(100% - ${DRAWER_WIDTH + 1 + NOTIFICATION_WIDTH}px)`,
    // width:
    //   !isChanakya && userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER
    //     ? `calc(100% - ${DRAWER_WIDTH + 1 + NOTIFICATION_WIDTH_XL}px)`
    //     : `calc(100% - ${DRAWER_WIDTH + 1}px)`,
    // [theme.breakpoints.up('lg')]: {
    //   left: DRAWER_WIDTH + 1,
    //   right: NOTIFICATION_WIDTH_XL,
    //   width:
    //     !isChanakya && userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER
    //       ? `calc(100% - ${DRAWER_WIDTH + 1 + NOTIFICATION_WIDTH_XL}px)`
    //       : `calc(100% - ${DRAWER_WIDTH + 1}px)`
    // },

    left: 0,
    right: 0,
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      left: DRAWER_WIDTH + 1,
      right: NOTIFICATION_WIDTH_XL,
      width:
        !isChanakya && userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER
          ? `calc(100% - ${DRAWER_WIDTH + 1 + NOTIFICATION_WIDTH_XL}px)`
          : `calc(100% - ${DRAWER_WIDTH + 1}px)`
    },
    /* Ultra-wide screens (1680px+) */
    '@media (min-width:1680px)': {
      left: DRAWER_WIDTH + 1,
      right: NOTIFICATION_WIDTH_XL,
      width:
        !isChanakya && userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER
          ? `calc(100% - ${DRAWER_WIDTH + 1 + NOTIFICATION_WIDTH_XLM}px)`
          : `calc(100% - ${DRAWER_WIDTH + 1}px)`
    }
  }));

  const debounceRef = useRef(null);

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'bottom',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: 'info'
  });

  const vertical = 'bottom';
  const horizontal = 'right';

  const handleSnackBarClose = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      searchFunction(e.target.value); // trigger immediately
    }
  };

  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={alertMetas?.snackBarOpened}
          onClose={handleSnackBarClose}
          autoHideDuration={6000}
        >
          <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
            {alertMetas?.msg}
          </Alert>
        </Snackbar>

        {/* <Box sx={{ flexGrow: 1 }} /> */}
        <Stack
          direction="row"
          spacing={1}
          sx={{ width: '100%' }}
          alignItems="center"
          justifyContent="space-between"
        >
          {location?.pathname === '/dashboard/soundboxT' && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Typography variant="h4" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
                  AudioCube
                </Typography>
                {/* <Typography
                  sx={{
                    fontSize: 14,
                    mt: 0.5,
                    ml: 0.4,
                    color: 'black',
                    fontWeight: 600
                  }}
                >
                  ®
                </Typography> */}
              </Box>

              {/* Date below */}
              {/* <Typography
                sx={{
                  fontSize: 10,
                  mt: 0,
                  color: '#5A5A5A',
                  fontFamily: 'Montserrat',
                  fontWeight: 600
                }}
              >
                Last Updated - 18 Dec 2025, 5:30 AM; Version - 5.1.1
              </Typography> */}
            </Box>
          )}

          {location?.pathname === '/dashboard/merchants' && (
            <Typography variant="h4" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              Merchants
            </Typography>
          )}
          {location?.pathname === '/dashboard/organizationusers' && (
            <Typography variant="h4" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              Users
            </Typography>
          )}
          {location?.pathname.includes('/dashboard/soundboxdevicedetails') && (
            <Typography variant="h5" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              <span style={{ whiteSpace: 'nowrap' }}>{name || 'Merchant Details'}</span>
            </Typography>
          )}
          {location?.pathname === '/dashboard/merchantOnboarding' && (
            <Typography variant="h5" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              <span style={{ whiteSpace: 'nowrap' }}>Merchant Verification</span>
            </Typography>
          )}
          {location?.pathname === '/dashboard/userProfile' && (
            <Typography variant="h5" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              <span style={{ whiteSpace: 'nowrap' }}>User Profile</span>
            </Typography>
          )}
          {location?.pathname === '/dashboard/ticketmanagement' && (
            <Typography variant="h5" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              <span style={{ whiteSpace: 'nowrap' }}>Ticket Management</span>
            </Typography>
          )}
          {location?.pathname === '/dashboard/regions' && (
            <Typography variant="h5" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              <span style={{ whiteSpace: 'nowrap' }}>Region Management</span>
            </Typography>
          )}
          {location?.pathname === '/dashboard/branches' && (
            <Typography variant="h5" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
              <span style={{ whiteSpace: 'nowrap' }}>Branch Management</span>
            </Typography>
          )}



          <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
            {search && (
              <MHidden width="mdDown">
                <Card
                  sx={{
                    width: '600px',
                    maxWidth: '100%',
                    height: '50px',
                    textAlign: 'center',
                    justifyContent: 'end',
                    ml: 'auto'
                  }}
                >
                  <Stack
                    direction="row"
                    sx={{ minHeight: '56px', pl: 2 }}
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <SearchSharpIcon sx={{ color: '#535353' }} />

                    <TextField
                      variant="standard"
                      placeholder={searchText}
                      onKeyDown={handleKeyDown}
                      InputProps={{
                        disableUnderline: true,
                        sx: { fontSize: '15px', fontWeight: 600, color: '#535353', opacity: 0.8 }
                      }}
                      fullWidth
                    />
                  </Stack>
                </Card>
              </MHidden>
            )}

            {/* <LanguagePopover /> */}
            {/* <Searchbar /> */}
            {/* <NotificationsPopover /> */}
            <AccountPopover />
            {/* <Button variant="contained" sx={{height:'50px'}} className={classes?.actionButtons} size='large' startIcon={<HelpOutlineOutlinedIcon />}>Help</Button> */}
          </Stack>
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
